@if (socialLinks.length > 0) {
  <div class="social-links">
    <div class="social-links__options" [class.social-links__options--centered]="centered">
      @for (link of socialLinks; track link) {
        <a
          [href]="getActionUrl(link)"
          [attr.aria-label]="getAriaLabel(link)"
          [attr.target]="isExternalLink(link) ? '_blank' : null"
          [attr.rel]="isExternalLink(link) ? 'noopener noreferrer' : null"
          (click)="handleClick($event, link)"
          class="social-links__button"
          >
          <div class="social-links__button-icon" [class]="'social-links__button-icon--' + link.type">
            <icon [name]="link.icon"></icon>
          </div>
          <span class="social-links__button-label">{{ link.label }}</span>
        </a>
      }
    </div>
  </div>
}
